'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-facebook/lib/constants/LikeSize.js
// module id = 747
// module chunks = 0